export default function(d) {
  return encodeURIComponent(d.format());
}



// WEBPACK FOOTER //
// ./src/utils/date-format.js